import { Config } from '../../config'

export const azerConfig: Config = {
  partner: 'azer',
  catalog: 'partner',
  displayName: 'Azer Scientific',
  accentColor: '#33449b',
  host: 'labchairs.azerscientific.com',
}
